<div class="d-flex justify-content-center align-items-center full-height">
  <div class="empty-box-height box-height auto-margin flex-column">
    <img imageName="something-went-wrong.svg" alt="loader" width="75px" />
    <p class="title-11 text-w-700">{{ error }}</p>
  </div>
</div>
